import { BreadCrumb } from "primereact/breadcrumb";
import { useEffect, useRef, useState } from "react";
import { routes } from "../../../routes";
import { FilterMatchMode } from "primereact/api";
import UserService from "../../../api/UserService";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import SearchComponent from "../../../components/datatable/SearchComponent";
import RoleService from "../../../api/RoleService";
import { DataTable } from "primereact/datatable";
import EmptyMessage from "../../../components/datatable/EmptyMessage";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { MultiSelect } from "primereact/multiselect";
import { ErrorMsg } from "../../../components/includes/styles/Styles";
import DeleteConfirmation from "../../../components/modal/DeleteConfirmation";
import { Toast } from "primereact/toast";
import { TextInput } from "../../../components/formLibs/FormLibs";
import { Chip } from "primereact/chip";

export default function Users() {
  const items = [{ label: "Utilisateurs" }];
  const [refresh, setRefresh] = useState(false);
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState([]);
  const [allRoles, setAllRoles] = useState([]);
  const [roles, setRoles] = useState([]);
  const [confirm, setConfirm] = useState(false);
  const [addVisible, setAddVisible] = useState(false);
  const [permissionVisible, setPermissionVisible] = useState(false);
  const toast = useRef(null);
  const [selectedRoles, setSelectedRoles] = useState(null);
  const candidate = {
    icon: "pi pi-lock",
    url: routes.dashboard.users.path,
  };
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    //name: { value: null, matchMode: FilterMatchMode.STARTS_WITH }
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  const schema = Yup.object({
    firstname: Yup.string()
      .required("Le prénom est obligatoire")
      .min(3, "Trop court")
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        "Uniquement des lettres svp !"
      ),
    lastname: Yup.string()
      .required("Le nom est obligatoire")
      .min(3, "Trop court")
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        "Uniquement des lettres svp !"
      ),
    email: Yup.string()
      .required("L'email est obligatoire")
      .email("Email invalide"),
  }).required();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ resolver: yupResolver(schema) });

  const header = () => {
    return (
      <div className="flex justify-content-between">
        <Button
          icon="pi pi-plus"
          label="Ajouter un utilisateur"
          onClick={() => setAddVisible(true)}
        />
        <SearchComponent
          globalFilterValue={globalFilterValue}
          onGlobalFilterChange={onGlobalFilterChange}
        />
      </div>
    );
  };
  useEffect(() => {
    setLoading(true);
    UserService.getAll()
      .then((res) => {
        setUsers(res.data.users);
        setLoading(false);
      })
      .catch((err) => {});
    RoleService.getAll()
      .then((res) => {
        setAllRoles(res.data.roles);
        //setLoading(false);
      })
      .catch((err) => {});
  }, [refresh]);

  const addUser = (data) => {
    setLoading(true);
    if (selectedRoles.length <= 0) {
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Erreur",
        detail: "Veuillez choisir au moins un role",
        life: 3000,
      });
    } else {
      selectedRoles.forEach((element) => {
        if (data.roles) {
          data.roles = [...data.roles, element.name];
        } else {
          data.roles = [element.name];
        }
      });
      UserService.create(data)
        .then((res) => {
          if (res.data.error) {
            toast.current.show({
              severity: "error",
              summary: "Erreur",
              detail: "Erreur de validation",
              life: 3000,
            });
            setLoading(false);
          } else {
            toast.current.show({
              severity: "success",
              summary: "Succès",
              detail: "Utilisateur créé avec succès",
              life: 5000,
            });
            setSelectedRoles([]);
            reset();
            setRefresh(!refresh);
            setAddVisible(false);
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          //setAddVisible(false);
          toast.current.show({
            severity: "error",
            summary: "Erreur",
            detail: "Erreur lors de l'ajout",
            life: 3000,
          });
        });
      setLoading(false);
    }
  };

  const deleteUser = () => {
    UserService.delete(user)
      .then((res) => {
        toast.current.show({
          severity: "info",
          summary: "Succèss",
          detail: "Utilisateur supprimé avec succès",
          life: 3000,
        });
        setRefresh(!refresh);
      })
      .catch((err) => {});
  };
  const rejectConfirmation = () => {
    toast.current.show({
      severity: "warn",
      summary: "Annulé",
      detail: "Vous aviez annulé la suppression",
      life: 3000,
    });
  };
  const removeRole = (id) => {
    RoleService.delete(id)
      .then((res) => {
        toast.current.show({
          severity: "info",
          summary: "Succèss",
          detail: "Role retiré avec succès",
          life: 3000,
        });
        setRefresh(!refresh);
      })
      .catch((err) => {});
  };

  return (
    <div className="pl-2 pr-2">
      <Toast ref={toast} />
      <DeleteConfirmation
        visible={confirm}
        onHide={() => setConfirm(false)}
        message={`Voulez-vous réellement supprimé l'utlisateur ${
          users.filter((rol) => rol.id === parseInt(user))[0]?.firstname +
          " " +
          users.filter((rol) => rol.id === parseInt(user))[0]?.lastname
        } ?`}
        accept={deleteUser}
        reject={rejectConfirmation}
      />
      <Dialog
        header="Ajouter utilisateur"
        visible={addVisible}
        style={{ width: "50vw" }}
        onHide={() => setAddVisible(false)}
      >
        <form className="form" onSubmit={handleSubmit(addUser)}>
          <div className="form__item">
            <label htmlFor="lastname">Nom</label>
            <div className="form__item__ic_p">
              <TextInput
                type="text"
                name="lastname"
                label="lastname"
                register={register}
              />
              <i className="pi pi-user"></i>
            </div>
            <ErrorMsg>{errors?.lastname?.message}</ErrorMsg>
          </div>
          <div className="form__item">
            <label htmlFor="firstname">Prénom(s)</label>
            <div className="form__item__ic_p">
              <TextInput
                type="text"
                name="firstname"
                register={register}
                label="firstname"
              />
              <i className="pi pi-user"></i>
            </div>
            <ErrorMsg>{errors.firstname?.message}</ErrorMsg>
          </div>
          <div className="form__item">
            <label htmlFor="email">Email</label>
            <div className="form__item__ic_p">
              <TextInput
                type="text"
                name="email"
                register={register}
                label="email"
              />
              <i className="pi pi-envelope"></i>
            </div>
            <ErrorMsg>{errors.email?.message}</ErrorMsg>
          </div>
          <div className="form__item">
            <label htmlFor="site">Parcours</label>
            <div className="form__item__ic_p">
              <MultiSelect
                value={selectedRoles}
                onChange={(e) => setSelectedRoles(e.value)}
                options={allRoles}
                optionLabel="name"
                placeholder="Sectionner un rôle"
                className="w-full"
                display="chip"
              />
            </div>
          </div>
          <div className="form__item">
            <button type="submit">
              Enregistrer{" "}
              <ProgressSpinner
                style={
                  loading
                    ? { width: "20px", height: "20px" }
                    : { width: "0px", height: "0px" }
                }
                strokeWidth="8"
                loading={loading}
              />
            </button>
          </div>
        </form>
      </Dialog>
      <Dialog
        header="Rôles associés"
        visible={permissionVisible}
        style={{ width: "50vw" }}
        onHide={() => setPermissionVisible(false)}
      >
        <DataTable
          value={roles}
          tableStyle={{ minWidth: "50rem" }}
          paginator
          rows={10}
          rowsPerPageOptions={[10, 25, 50]}
          dataKey="id"
          filters={filters}
          loading={loading}
          //globalFilterFields={["name"]}
          emptyMessage={EmptyMessage}
        >
          <Column field="name" header="Nom" style={{ width: "100%" }}></Column>
        </DataTable>
      </Dialog>
      <div>
        <BreadCrumb model={items} home={users} />
      </div>
      <div className="">
        <DataTable
          value={users}
          tableStyle={{ minWidth: "50rem" }}
          paginator
          rows={5}
          rowsPerPageOptions={[5, 10, 25, 50]}
          dataKey="id"
          filters={filters}
          loading={loading}
          globalFilterFields={["firstname", "lastname", "email"]}
          header={header}
          emptyMessage={EmptyMessage}
        >
          <Column
            body={(rowData) => rowData.lastname + " " + rowData.firstname}
            header="Nom et Prenom"
          ></Column>
          <Column body={(rowData) => rowData.email} header="Email"></Column>
          <Column
            body={(rowData) =>
              rowData?.roles?.map((rol, index) => (
                <div className="flex gap-1 flex-wrap" key={index}>
                  <Chip
                    label={rol.name}
                    removable
                    onRemove={() => removeRole(rol.id)}
                    className="my-2"
                  />
                </div>
              ))
            }
            header="Roles"
          ></Column>

          {/* <Column
            header="Action"
            //body={actionTemplate}
            style={{ width: "50%" }}
          ></Column> */}
        </DataTable>
      </div>
    </div>
  );
}
